const body       = document.body;
const siteHeader = document.querySelector(`.js--site-header`);
const menuBtn    = document.querySelector(`.js--mobile-navigation__menu-button`);
const mobileMenu = document.querySelector(`.js--mobile-navigation`);


// ---------------------------------------------------------------------------
// Show/hide header on scroll

// Toggle Header
function toggleHeader(){
  // Initial state
  var scrollPosition = window.scrollY; // maybe set to 0

  // Detect scroll direction and header's distance from top
  window.addEventListener('scroll', function(){
    // Scroll Up
    if ((document.body.getBoundingClientRect()).top > scrollPosition) {
      siteHeader.classList.add(`-is-active`)

    // Scrolling Down
    } else {
      // If header is further than 300px away from top of screen
      if (scrollPosition <= -300) {
        siteHeader.classList.remove(`-is-active`);
      }
    }

    // saves the new position for iteration.
    scrollPosition = (document.body.getBoundingClientRect()).top;
  });
}

// Toggle Mobile
function toggleMobile(){
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  if (viewportWidth > 1024) {
    // Remove overflow-hidden on body
    body.removeAttribute(`style`)

    // Unactivate hamburger
    menuBtn.classList.remove(`-is-active`);
    menuBtn.setAttribute(`aria-expanded`, false);

    // Unactivate mobile menu
    mobileMenu.classList.remove(`-is-active`);

  } else {
  }
}

// Toggle Header + Mobile
toggleHeader();
toggleMobile();

// On Resize
window.addEventListener(`resize`, function () {
  // Toggle Mobile
  toggleMobile();
}, false);


// ---------------------------------------------------------------------------
// Reveal Mobile Menu On Hamburger Click
menuBtn.onclick = function(){
  body.style.overflow = `hidden`;
  this.classList.toggle(`-is-active`);
  mobileMenu.classList.toggle(`-is-active`);

  if (this.classList.contains(`-is-active`)) {
    this.setAttribute(`aria-expanded`, `true`);
  } else {
    body.removeAttribute(`style`);
    this.setAttribute(`aria-expanded`, `false`);
  }
};

// ---------------------------------------------------------------------------
// Reveal Mobile Menu Dropdown On Trigger Click
const mobileNavDropdownItems = document.querySelectorAll(`.js--mobile-navigation__dropdown-trigger`);

mobileNavDropdownItems.forEach(mobileNavDropdownItem => {
  mobileNavDropdownItem.onclick = function(){
    const dropdownId = this.getAttribute(`aria-controls`);
    const listItem = this.closest(`li`);
    let dropdown = null;

    if (dropdownId) {
      dropdown = document.getElementById(dropdownId);
    } else if (listItem) {
      dropdown = listItem.querySelector(`.css--mobile-navigation__dropdown`);
    }

    if (!dropdown) {
      return;
    }

    const isActive = this.classList.toggle(`-is-active`);
    dropdown.classList.toggle(`-is-active`, isActive);
    this.setAttribute(`aria-expanded`, isActive ? `true` : `false`);
  };
});
